"use client";

import { createContext, useContext, useState } from "react";

interface ProductQtyContextType {
  qty: number;
  setQty: (qty: number) => void;
}

const ProductQtyContext = createContext<ProductQtyContextType>({
  qty: 1,
  setQty: () => {},
});

export function ProductQtyProvider({ children }: { children: React.ReactNode }) {
  const [qty, setQty] = useState(1);
  return (
    <ProductQtyContext.Provider value={{ qty, setQty }}>
      {children}
    </ProductQtyContext.Provider>
  );
}

export function useProductQty() {
  return useContext(ProductQtyContext);
}
